import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import MobileAppPromo from "./components/MobileAppPromo";

const MainSreen = lazy(() => import("./screens/mainScreen"));
const LoginScreen = lazy(() => import("./screens/loginScreen"));
const FaqPage = lazy(() => import("./screens/components/FAQ"));
const SettingsScreen = lazy(() => import("./screens/SettingsScreen"));
const PrivacyPolicy = lazy(() => import("./screens/PrivacyPolicy"));
const SettPassordScreen = lazy(() => import("./screens/SettPassordScreen"));

function App() {
  return (
    <>
      <MobileAppPromo />
      <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Laster...</div>}>
        <Routes>
          <Route path='/' element={<MainSreen />} />
          <Route path='/login' element={<LoginScreen />} />
          <Route path='/sett-passord' element={<SettPassordScreen />} />
          <Route path='/faq' element={<FaqPage />} />
          <Route path='/innstillinger' element={<SettingsScreen />} />
          <Route path='/personvern' element={<PrivacyPolicy />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
